<template>
    <span>
        <span class="text-primary mr-2" v-if="pagamentoNotaFiscal.documentoId || pagamentoNotaFiscal.caminhoArquivo">
            <i
                class="fa fa-search fa-lg icon-button"
                title="Visualizar Anexo da Nota Fiscal"
                @click.stop="abrirModal()"
            ></i>
        </span>

        <!-- Modal para visualização -->
        <b-modal
            :id="'modalVisualizarAnexo_' + pagamentoNotaFiscal.pagamentoNotaFiscalId"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            :title="'Visualizar Anexo - NF ' + (pagamentoNotaFiscal.numeroNota || 'N/A')"
        >
            <div v-if="carregando" class="text-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Carregando...</span>
                </div>
                <p class="mt-2">Carregando documento...</p>
            </div>

            <iframe
                v-if="arquivo"
                :src="arquivo"
                style="width: 100%; height: 600px; border: none;"
                title="Visualização do anexo da nota fiscal"
            >
            </iframe>

            <div slot="modal-footer">
                <b-button variant="secondary" @click="fecharModal()">
                    <i class="fa fa-times"></i> Fechar
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
export default {
    props: {
        pagamentoNotaFiscal: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            arquivo: null,
            carregando: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.carregando = true
            this.arquivo = null

            this.$store.dispatch('addRequest')
            
            this.pagamentosServicos
                .downloadNotaFiscal(this.pagamentoNotaFiscal.pagamentoNotaFiscalId)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro ao carregar o documento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            // Usar o mesmo padrão dos componentes que funcionam
                            const blob = new Blob([response], { type: 'application/pdf' })
                            this.arquivo = window.URL.createObjectURL(blob)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                    this.carregando = false
                })
                .catch(error => {
                    console.error('Erro ao carregar anexo:', error)
                    this.$toast.error(
                        'Erro ao carregar o documento!',
                        'ERROR',
                        this.$toastConfig.error
                    )
                    this.$store.dispatch('removeRequest')
                    this.carregando = false
                })
        },

        fecharModal() {
            this.mostrarModal = false
            if (this.arquivo) {
                window.URL.revokeObjectURL(this.arquivo)
                this.arquivo = null
            }
        }
    },

    beforeDestroy() {
        // Limpar URL do objeto ao destruir o componente
        if (this.arquivo) {
            window.URL.revokeObjectURL(this.arquivo)
        }
    }
}
</script>

<style scoped>
.icon-button {
    cursor: pointer;
    transition: color 0.2s ease;
}

.icon-button:hover {
    color: #0056b3 !important;
}

.spinner-border {
    width: 3rem;
    height: 3rem;
}
</style>
